import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, Input } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { insert, selectValues, update, validarCNPJ, validarCPF } from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { notifyError, notifySuccess } from '../../../utils/notify';
import { linkOikosLabVM, linkProducaoVM } from '../../../utils/linksOikos/link';

const b64urlEncode = (value) => {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const PAYLOAD_CADASTRO_FORNECEDOR = {
  informacoes_gerais: {
    nome_ou_razao_social: null,
    email: null,
    cpf_ou_cnpj: null,
    telefone: null,
  },
  endereco: {
    logradouro: null,
    numero: null,
    complemento: null,
  },
  dados_bancarios: {
    banco: null,
    agencia: null,
    conta: null,
    tipo_pix: null,
    chave_pix: null,
  },
};

const ModalFormAddPjOuPf = ( props ) => {

  const [addFavModal, setAddFavModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [identificador, setIdentificador] = useState('');
  const [telefone, setTelefone] = useState('');
  const [endLogr, setEndLogr] = useState('');
  const [endNum, setEndNum] = useState('');
  const [endCompl, setEndCompl] = useState('');
  const [banco, setBanco] = useState(null);
  const [agencia, setAgencia] = useState('');
  const [numeroConta, setNumeroConta] = useState('');
  const [tipoPix, setTipoPix] = useState(null);
  const [pix, setPix] = useState('');
  const [selBancos, setSelBancos] = useState([]);
  const [selectTipoPix, setSelectTipoPix] = useState([]);


  const handleClickOpenAddFavModal = () => setAddFavModal(true);
  const handleClickCloseAddFavModal = () => setAddFavModal(false);

  const handleCopyLinkCadastroFornecedor = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      const hash = b64urlEncode(JSON.stringify(PAYLOAD_CADASTRO_FORNECEDOR));
      const link = `${linkProducaoVM}formCriaPfOuPj.php#${hash}`;
      await navigator.clipboard.writeText(link);
      notifySuccess('Link copiado para a área de transferência.');
    } catch (error) {
      console.error('Erro ao copiar link de cadastro do fornecedor:', error);
      notifyError('Não foi possível copiar o link.');
    }
  };

  const renderModalHeader = () => (
    <div className="modal-header d-flex justify-content-between align-items-center">
      <h5 className="modal-title mb-0">Adicionar</h5>
      <Btn
        type="button"
        size="sm"
        color="link"
        className="ml-3 p-0"
        onClick={handleCopyLinkCadastroFornecedor}
      >
        Link para o fornecedor se cadastrar
      </Btn>
    </div>
  );

  async function getCNPJInfo(cnpj) {
    const res = await fetch(`https://www.receitaws.com.br/v1/cnpj/${cnpj}`)
    console.log(res);
    return res;
  }
  const checkCamposObrigatorios = () => {
    if (!nome.trim() || !email.trim() || !identificador.trim() || !telefone.trim()) {
      notifyError('Por favor, preencha todos os campos obrigatórios (Nome, Email, Identificador e Telefone).');
      return false;
    }
    return true;
  }

  const verificaIdentificador = async (isPf) => {
    var exists = false;

    if (isPf) {
      const pf = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_cpf: identificador,
        }
      })}`);

      if (pf.data[0]) {
        exists = true
      };
    }

    else {
      const pj = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: {
          pj_cnpj: identificador,
        }
      })}`);

      if (pj.data[0]) {
        exists = true
      };
    }

    return exists;
  }

  const handleSubmit = async () => {
    const check = checkCamposObrigatorios();
    if (check === false) {
       return; 
    }
    setIsLoading(true);

    let createdId = null;
    let createdRegisterTab = null;

    const existFav = await verificaIdentificador(props.isPf);
    if (existFav) {
      setIsLoading(false);
      if(props.isPf) return alert('Pessoa Física já existe');
      if(!props.isPf) return alert('Pessoa Jurídica já existe');
    }

    if (props.isPf) {
      const pfBody = {
          action: 'insert',
          table: 'pf',
          data: {
          pf_nomeExibicao: nome,
          pf_emailProf: email,
          pf_cpf: identificador,
          pf_endLogr: endLogr || undefined,
          pf_endNum: endNum || undefined,
          pf_endCompl: endCompl || undefined,
          pf_contaBanco: banco?.value || undefined,
          pf_contaAgencia: agencia || undefined,
          pf_contaNum: numeroConta || undefined,
          pixTp_id: tipoPix?.value || undefined,
          pf_chavePix: pix || undefined,
          pf_celProf: telefone,
          pf_fornecedor: 1,
        }
      }

      const cpfValido = await validarCPF(identificador);
      if (!cpfValido) {
        setIsLoading(false);
        return alert('CPF inválido');
      }

      const pfCreated = await oikosApi.post('/', pfBody)
      createdId = pfCreated.data[0].pf_id
      createdRegisterTab = 'pf';
      if (props.setSelPfsFornecedor) props.setSelPfsFornecedor((prev) => { return [ ...prev, {label: pfCreated.data[0].pf_nomeExibicao, value: pfCreated.data[0].pf_id}] })

    } else {
      const pjBody = {
        action: 'insert',
        table: 'pj',
        data: {
          pj_razaosocial: nome,
          pj_emailPrin: email,
          pj_cnpj: identificador,
          pj_endLogr: endLogr || undefined,
          pj_endNum: endNum || undefined,
          pj_endCompl: endCompl || undefined,
          pj_contaBanco: banco?.value || undefined,
          pj_contaAgencia: agencia || undefined,
          pj_contaNum: numeroConta || undefined,
          pixTp_id: tipoPix?.value || undefined,
          pj_chavePix: pix || undefined,
          pj_telPrin: telefone,
          pj_fornecedor: 1,
        }
      }

      const cnpjValido = await validarCNPJ(identificador);
      if (!cnpjValido) {
        setIsLoading(false);
        return alert('CNPJ inválido');
      }

      const pjCreated = await oikosApi.post('/', pjBody)
      createdId = pjCreated.data[0].pj_id
      createdRegisterTab = 'pj';

      if (props.setSelPjsFornecedor) props.setSelPjsFornecedor((prev) => { return [ ...prev, {label: pjCreated.data[0].pj_razaosocial, value: pjCreated.data[0].pj_id}] })

    }

    if (props.setContrFornData) {
      console.log('setContrFornData');
      props.setContrFornData({ ...props.contrFornData, contrForn_parteId: createdId, contrForn_parteTab: createdRegisterTab });
    }
    if (props.getFornecedores) {
      console.log('getFornecedores');
      props.getFornecedores(props.isPf);
    }

    /*
    */
   if (props.fetchSelPfs) {
     console.log('fetchSelPfs');
     props.fetchSelPfs();
   }
   if (props.handleClickCloseAddFavModal) {
     console.log('handleClickCloseAddFavModal');
     props.handleClickCloseAddFavModal();
   }


    setIsLoading(false);
    handleClickCloseAddFavModal();
  }

  const preloading = async () => {
    try {
      const [pixOptions, resBancos] = await Promise.all([
        selectValues('pixTp', 'pixTp_id', 'pixTp_nome', { pixTp_ativo: 1 }),
        oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'banco',
        })}`),
      ]);

      setSelectTipoPix(pixOptions || []);
      setSelBancos((resBancos?.data || [])
        .map((item) => ({
          value: item.banco_id,
          label: item.banco_cod ? `${item.banco_cod} - ${item.banco_nome}` : item.banco_nome,
        }))
        .sort((a, b) => String(a.label).localeCompare(String(b.label), 'pt-BR')));
    } catch (error) {
      console.error('Erro ao carregar opções de banco e tipo PIX:', error);
    }
  };

  const renderCamposIdentificacao = (nomeLabel, documentoLabel) => (
    <>
      <Row>
        <Col sm={6}>
          <FormGroup className="mb-2">
            <Label>{nomeLabel}</Label>
            <Input
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup className="mb-2">
            <Label>E-mail</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <FormGroup className="mb-2">
            <Label>{documentoLabel}</Label>
            <Input
              value={identificador}
              onChange={(e) => setIdentificador(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup className="mb-2">
            <Label>Telefone</Label>
            <Input
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );

  const renderEnderecoEDadosBancarios = () => (
    <>
      <Label className="font-weight-bold d-block mt-2 mb-1">Endereço</Label>
      <Row>
        <Col sm={12}>
          <FormGroup className="mb-2">
            <Label>Logradouro</Label>
            <Input
              type="text"
              value={endLogr}
              onChange={(e) => setEndLogr(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <FormGroup className="mb-2">
            <Label>Número</Label>
            <Input
              type="text"
              value={endNum}
              onChange={(e) => setEndNum(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col sm={8}>
          <FormGroup className="mb-2">
            <Label>Complemento</Label>
            <Input
              type="text"
              value={endCompl}
              onChange={(e) => setEndCompl(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>

      <Label className="font-weight-bold d-block mt-2 mb-1">Dados bancários</Label>
      <Row>
        <Col sm={4}>
          <FormGroup className="mb-2">
            <Label>Banco</Label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              placeholder="Selecione um banco"
              isClearable
              isSearchable
              options={selBancos}
              value={banco}
              onChange={(option) => setBanco(option || null)}
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup className="mb-2">
            <Label>Número da agência</Label>
            <Input
              type="text"
              value={agencia}
              onChange={(e) => setAgencia(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup className="mb-2">
            <Label>Número da conta</Label>
            <Input
              type="text"
              value={numeroConta}
              onChange={(e) => setNumeroConta(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <FormGroup className="mb-2">
            <Label>Tipo de pix</Label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              placeholder="Selecione o tipo de pix"
              isClearable
              isSearchable
              options={selectTipoPix}
              value={tipoPix}
              onChange={(option) => setTipoPix(option || null)}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup className="mb-2">
            <Label>Chave pix</Label>
            <Input
              type="text"
              value={pix}
              onChange={(e) => setPix(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );

  useEffect(() => {
    preloading()
  },[])

  return (
    <>
      <Btn
        size="sm"
        color="link"
        className="ml-2 px-0"
        onClick={(e)=>{
          e.preventDefault();
          handleClickOpenAddFavModal();
          //console.log(getCNPJInfo('08022237000185'))
        }}
      >
        Adicionar nova {(props.isPf) ?  'PF' : 'PJ' }
      </Btn>
      {(props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
          size="lg"
        >
          {renderModalHeader()}
          <ModalBody>
            {renderCamposIdentificacao('Nome', 'CPF (apenas números)')}
            {renderEnderecoEDadosBancarios()}
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async (e) => {
                  //insOrUp( 'projStake', addStakeProjData)
                  console.log('inseriu');
                  await handleSubmit()
                  //handleClickCloseAddFavModal();
                }
                }
              >
                Adicionar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
      {(!props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
          size="lg"
        >
          {renderModalHeader()}
          <ModalBody>
            {renderCamposIdentificacao('Razão Social', 'CNPJ (apenas números)')}
            {renderEnderecoEDadosBancarios()}
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async () => {
                  console.log('inseriu');
                  await handleSubmit()
                }
                }
              >
                Adicionar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
    </>
  )
}

export default ModalFormAddPjOuPf;
